import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from 'react-query'
import { persistor } from '../../../store/store'

export default () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  useEffect(() => {
    axios
      .get('/api/auth/logout')
      .then((response) => response.data)
      .then((logoutResponse) => {
        queryClient.invalidateQueries()
        persistor.pause()
        persistor.flush().then(() => {
          setTimeout(() => {
            persistor.purge().then(() => {
              logoutResponse.externalLogin && logoutResponse.wasLoggedIn
                ? navigate('/auth/logout-external', {
                    state: { redirectUrl: logoutResponse.redirectUrl },
                  })
                : navigate('/auth/login')
            })
          }, 200)
        })
      })
  }, [])
  return null
}
